<div class="table-container">
  <mat-tab-group mat-stretch-tabs="true" style="height: 100%;">

    <!-- ═══ tCC TAB ═══ -->
    <mat-tab label="tCC Tickets">
      <div class="actions-bar">
        <button mat-button (click)="onAddReport('tCC')">
          <mat-icon>equalizer</mat-icon>New report
        </button>
        <button mat-raised-button color="primary" (click)="onNewTicket('tCC')" [disabled]="!canCreateTicket">
          <mat-icon>add</mat-icon>New ticket
        </button>
      </div>

      <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <mat-form-field appearance="fill" class="filter-field">
          <mat-label>Search tickets</mat-label>
          <input type="text" [(ngModel)]="tccSearchbarEntry" matInput (keyup)="onTccSearchInput($event)"
            placeholder="e.g. Name, Mail" />
        </mat-form-field>
        <span class="example-spacer"></span>
        <button mat-icon-button matTooltip="Filters" cdkOverlayOrigin #tccFilterTrigger="cdkOverlayOrigin"
          (click)="tccFilterOpen = !tccFilterOpen"><mat-icon>filter_list</mat-icon></button>
        <button mat-icon-button [matMenuTriggerFor]="tccMenu"
          matTooltip="Table settings"><mat-icon>settings</mat-icon></button>
        <button mat-icon-button matTooltip="Download table" (click)="onDownloadAll('tCC')"
          [disabled]="tccExportLoading">
          <mat-icon *ngIf="!tccExportLoading">save_alt</mat-icon>
          <mat-spinner *ngIf="tccExportLoading" diameter="20"></mat-spinner>
        </button>
        <button mat-icon-button matTooltip="Reload table"
          (click)="initTccData(tccCurrentHttpParams)"><mat-icon>refresh</mat-icon></button>
      </div>

      <mat-chip-set class="active-filter-chips" *ngIf="tccActiveFilterChips.length">
        <mat-chip *ngFor="let chip of tccActiveFilterChips" [removable]="true"
          (removed)="removeActiveFilterChip(chip, 'tCC')">
          {{ chip.display }}: <strong>{{ chip.value }}</strong>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-set>

      <div class="table-wrapper" [hidden]="isLoading || tccDataSource.data.length == 0">
        <table mat-table [dataSource]="tccDataSource" matSort [matSortActive]="tccSortActive"
          [matSortDirection]="tccSortDirection" matSortDisableClear (matSortChange)="onTccSortChange($event)"
          #tccSort="matSort" class="ticket-table">
          <ng-container *ngFor="let chip of tccChips" [matColumnDef]="chip.value">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ chip.display }}</th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="chip.display != 'Actions' && chip.display != 'Ticket Id' && !isSearchableColumn(chip.value)">
                {{ element[chip.value] }}
              </div>

              <!-- searchable text columns get highlighted matches -->
              <div *ngIf="isSearchableColumn(chip.value) && chip.display != 'Actions' && chip.display != 'Ticket Id'"
                [innerHTML]="element[chip.value] | highlight: tccSearchbarEntry">
              </div>

              <div *ngIf="chip.display == 'Actions'">
                <button mat-icon-button color="secondary" [matMenuTriggerFor]="tccActionMenu"
                  [matMenuTriggerData]="{data: element}" (click)="$event.stopPropagation()"
                  [disabled]="element['pct_organization'] != currentUser.getUser().org_name">
                  <mat-icon>more_vert</mat-icon></button>
              </div>

              <div *ngIf="chip.display == 'Ticket Id'" style="display:flex;align-items:center">
                <span [innerHTML]="element[chip.value] | highlight: tccSearchbarEntry"></span>
                <mat-icon style="scale:0.65" color="primary"
                  [matTooltip]="'This ticket (' + element['pct_organization'] + ') does not belong to your current organization. Editing is disabled.'"
                  *ngIf="element['pct_organization'] != currentUser.getUser().org_name">warning</mat-icon>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="tccDisplayedColumns" class="mat-header-row"></tr>
          <tr mat-row class="table-row" *matRowDef="let row; columns: tccDisplayedColumns;" (click)="onEdit(row.id)">
          </tr>
        </table>
      </div>
      <div class="loading-wrapper" *ngIf="isLoading"><mat-spinner></mat-spinner></div>
      <div class="loading-wrapper" *ngIf="!isLoading && tccDataSource.data.length == 0">
        <div><mat-icon color="primary" style="transform:scale(2);margin-bottom:10px">cloud_off</mat-icon></div>
        <div>No tickets match your filter</div>
      </div>
      <div class="paginator-container">
        <mat-paginator #tccPaginator="matPaginator" [length]="tccTotal" [pageSize]="tccLimit" [pageIndex]="tccPage - 1"
          [pageSizeOptions]="[30, 20, 10]" showFirstLastButtons (page)="onTccPageChange($event)">
        </mat-paginator>
      </div>
    </mat-tab>

    <!-- ═══ pCC TAB ═══ -->
    <mat-tab label="pCC Tickets">
      <div class="actions-bar">
        <button mat-raised-button color="primary" (click)="onNewTicket('pCC')" [disabled]="!canCreateTicket">
          <mat-icon>add</mat-icon>New ticket
        </button>
      </div>

      <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <mat-form-field appearance="fill" class="filter-field">
          <mat-label>Search tickets</mat-label>
          <input type="text" matInput [(ngModel)]="pccSearchbarEntry" (keyup)="onPccSearchInput($event)"
            placeholder="e.g. Name, Mail" />
        </mat-form-field>
        <span class="example-spacer"></span>
        <button mat-icon-button matTooltip="Filters" cdkOverlayOrigin #pccFilterTrigger="cdkOverlayOrigin"
          (click)="pccFilterOpen = !pccFilterOpen"><mat-icon>filter_list</mat-icon></button>
        <button mat-icon-button [matMenuTriggerFor]="pccMenu"
          matTooltip="Table settings"><mat-icon>settings</mat-icon></button>
        <button mat-icon-button matTooltip="Download table" (click)="onDownloadAll('pCC')"
          [disabled]="pccExportLoading">
          <mat-icon *ngIf="!pccExportLoading">save_alt</mat-icon>
          <mat-spinner *ngIf="pccExportLoading" diameter="20"></mat-spinner>
        </button>
        <button mat-icon-button matTooltip="Reload table"
          (click)="initPccData(pccCurrentHttpParams)"><mat-icon>refresh</mat-icon></button>
      </div>

      <mat-chip-set class="active-filter-chips" *ngIf="pccActiveFilterChips.length">
        <mat-chip *ngFor="let chip of pccActiveFilterChips" [removable]="true"
          (removed)="removeActiveFilterChip(chip, 'pCC')">
          {{ chip.display }}: <strong>{{ chip.value }}</strong>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-set>

      <div class="table-wrapper" [hidden]="isLoading || pccDataSource.data.length == 0">
        <table mat-table [dataSource]="pccDataSource" matSort [matSortActive]="pccSortActive"
          [matSortDirection]="pccSortDirection" matSortDisableClear (matSortChange)="onPccSortChange($event)"
          #pccSort="matSort" class="ticket-table">
          <ng-container *ngFor="let chip of pccChips" [matColumnDef]="chip.value">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ chip.display }}</th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="chip.display != 'Actions' && chip.display != 'Ticket Id' && !isSearchableColumn(chip.value)">
                {{ element[chip.value] }}
              </div>

              <!-- searchable text columns get highlighted matches -->
              <div *ngIf="isSearchableColumn(chip.value) && chip.display != 'Actions' && chip.display != 'Ticket Id'"
                [innerHTML]="element[chip.value] | highlight: pccSearchbarEntry">
              </div>

              <div *ngIf="chip.display == 'Actions'">
                <button mat-icon-button color="secondary" [matMenuTriggerFor]="pccActionMenu"
                  [matMenuTriggerData]="{data: element}" (click)="$event.stopPropagation()"
                  [disabled]="element['pct_organization'] != currentUser.getUser().org_name">
                  <mat-icon>more_vert</mat-icon></button>
              </div>

              <div *ngIf="chip.display == 'Ticket Id'" style="display:flex;align-items:center">
                <span [innerHTML]="element[chip.value] | highlight: pccSearchbarEntry"></span>
                <mat-icon style="scale:0.65" color="primary"
                  [matTooltip]="'This ticket (' + element['pct_organization'] + ') does not belong to your current organization. Editing is disabled.'"
                  *ngIf="element['pct_organization'] != currentUser.getUser().org_name">warning</mat-icon>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="pccDisplayedColumns" class="mat-header-row"></tr>
          <tr mat-row class="table-row" *matRowDef="let row; columns: pccDisplayedColumns;" (click)="onEdit(row.id)">
          </tr>
        </table>
      </div>



      <div class="loading-wrapper" *ngIf="isLoading"><mat-spinner></mat-spinner></div>
      <div class="loading-wrapper" *ngIf="!isLoading && pccDataSource.data.length == 0">
        <div><mat-icon color="primary" style="transform:scale(2);margin-bottom:10px">cloud_off</mat-icon></div>
        <div>No tickets match your filter</div>
      </div>
      <div class="paginator-container">
        <mat-paginator #pccPaginator="matPaginator" [length]="pccTotal" [pageSize]="pccLimit" [pageIndex]="pccPage - 1"
          [pageSizeOptions]="[30, 20, 10]" showFirstLastButtons (page)="onPccPageChange($event)">
        </mat-paginator>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>

<!-- MENUS (unchanged) -->
<mat-menu #tccMenu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item *ngFor="let tccchip of tccChips" (click)="$event.stopPropagation()"
      (click)="toggleSelection('tcc', tccchip)">
      {{ tccchip.display }}
      <mat-icon *ngIf="tccchip.selected" color="primary" (click)="$event.stopPropagation()" (click)="toggleSelection('tcc', tccchip)">visibility</mat-icon>
      <mat-icon *ngIf="!tccchip.selected" (click)="$event.stopPropagation()" (click)="toggleSelection('tcc', tccchip)">visibility_off</mat-icon>
    </button>
  </ng-template>
</mat-menu>

<mat-menu #pccMenu="matMenu">
  <button mat-menu-item *ngFor="let pccchip of pccChips" (click)="$event.stopPropagation()"
    (click)="toggleSelection('pcc', pccchip)">
    {{ pccchip.display }}
    <mat-icon *ngIf="pccchip.selected" color="primary" (click)="$event.stopPropagation()" (click)="toggleSelection('pcc', pccchip)">visibility</mat-icon>
    <mat-icon *ngIf="!pccchip.selected" (click)="$event.stopPropagation()" (click)="toggleSelection('pcc', pccchip)">visibility_off</mat-icon>
  </button>
</mat-menu>

<mat-menu #tccActionMenu="matMenu">
  <ng-template matMenuContent let-data="data">
    <button mat-menu-item [disabled]="!canCreateTicket"
      (click)="onDuplicateTicket(data)">Duplicate<mat-icon>control_point_duplicate</mat-icon></button>
    <button mat-menu-item [mat-menu-trigger-for]="movingOrgMenu" [matMenuTriggerData]="{data: data}"
      [disabled]="!canMoveTicket"><mat-icon>arrow_upward</mat-icon>Move to Org</button>
  </ng-template>
</mat-menu>

<mat-menu #pccActionMenu="matMenu">
  <ng-template matMenuContent let-data="data">
    <button mat-menu-item [disabled]="!canCreateTicket"
      (click)="onDuplicateTicket(data)">Duplicate<mat-icon>control_point_duplicate</mat-icon></button>
    <button mat-menu-item (click)="onMoveTotCC(data)"><mat-icon>arrow_upward</mat-icon>Move to tCC</button>
  </ng-template>
</mat-menu>

<mat-menu #movingOrgMenu="matMenu">
  <ng-template matMenuContent let-data="data">
    <button *ngFor="let org of allOrganizations" mat-menu-item (click)="onMoveToOrg(data, org.org_name)">{{ org.org_name
      }}</button>
  </ng-template>
</mat-menu>

<!-- tCC FILTER OVERLAY -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="tccFilterTrigger"
  [cdkConnectedOverlayOpen]="tccFilterOpen" [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" (backdropClick)="tccFilterOpen = false"
  [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 }]">
  <div class="filter-panel">
    <app-p-ticket-filter tableName="tCC" [filters]="tccFilters" (httpFilterList)="initTccData($event)"
      (filtersChanged)="tccFilters = $event" (applied)="tccFilterOpen = false" #tccTicketFilter>
    </app-p-ticket-filter>
  </div>
</ng-template>

<!-- pCC FILTER OVERLAY -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="pccFilterTrigger"
  [cdkConnectedOverlayOpen]="pccFilterOpen" [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" (backdropClick)="pccFilterOpen = false"
  [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 }]">
  <div class="filter-panel">
    <app-p-ticket-filter tableName="pCC" [filters]="pccFilters" (httpFilterList)="initPccData($event)"
      (filtersChanged)="pccFilters = $event" (applied)="pccFilterOpen = false" #pccTicketFilter>
    </app-p-ticket-filter>
  </div>
</ng-template>